import { navItems } from '@/data/navigation';
import { profile } from '@/data/profile';
import { SocialLinks } from '@/components/common/SocialLinks';
import styles from './Footer.module.css';

export function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={`container ${styles.inner}`}>
        <div className={styles.brandBlock}>
          <p className={styles.name}>{profile.fullName}</p>
          <p className={styles.copy}>
            © {year} {profile.fullName}. Built with care in {profile.location}.
          </p>
        </div>

        <nav aria-label="Footer">
          <ul className={styles.links}>
            {navItems.map((item) => (
              <li key={item.id}>
                <a href={item.href}>{item.label}</a>
              </li>
            ))}
          </ul>
        </nav>

        <SocialLinks />
      </div>
    </footer>
  );
}
